import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';

import { useStarterDashboardV2PageFcm } from 'src/app/pages/starterDashboardV2/pageContext';
import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';

import type { PreviewEmailButtonProps } from '../../types';

export function PreviewEmailButton({ disabled, onClick }: PreviewEmailButtonProps): JSX.Element | null {
	const { petitionUpdateEmailPreviewEnabled } = useStarterDashboardV2PageFcm();
	const { getCTAVariant } = useCTAButtonVariant();

	if (!petitionUpdateEmailPreviewEnabled) {
		return null;
	}

	return (
		<Button
			variant={getCTAVariant('secondaryEmphasis')}
			data-testid="preview-petition-update"
			data-qa="preview-petition-update"
			onClick={onClick}
			type="button"
			disabled={disabled}
			mb={[16, 0]}
			mr={[0, 16]}
		>
			<Translate value="corgi.petition_update.preview_button" />
		</Button>
	);
}
